import {dateTime} from "services/date";
import {Membership} from "types/Membership";
import deserializeMembershipPlan from "services/ngage/deserializers/membership-plan";

/**
 * Transform the given membership by deserializing object properties
 *
 * @internal
 * @param membership
 */
export default function deserializeMembership(membership: any): Membership {
    membership.plan = deserializeMembershipPlan(membership.plan)
    membership.issued_at = dateTime(membership.issued_at)
    membership.valid_at = dateTime(membership.valid_at)
    membership.expires_at = dateTime(membership.expires_at)
    membership.revoked_at = dateTime(membership.revoked_at)
    membership.created_at = dateTime(membership.created_at)
    membership.updated_at = dateTime(membership.updated_at)

    return membership;
}